import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { Box, Typography } from '@mui/material';
import NordicToggleButtonGrid from './NordicToggleButtonGrid';
import languages from '../../../language/languages';

const NordicWeekScale2: FC = () => {
  const week = useSelector((state: RootState) => state.nordicForm.weekCheck);
  const { selected } = useSelector((state: RootState) => state.language);
  const scale: any[] = [];
  if (week.cuello === true) {
    scale.push({ name: 'cuello', tag: languages[selected].nordic.body.cuello });
  }
  if (week.hombro === true) {
    scale.push({ name: 'hombro', tag: languages[selected].nordic.body.hombro });
  }
  if (week.brazoCodo === true) {
    scale.push({ name: 'brazoCodo', tag: languages[selected].nordic.body.brazoCodo });
  }
  if (week.manoMuñeca === true) {
    scale.push({ name: 'manoMuñeca', tag: languages[selected].nordic.body.manoMuñeca });
  }
  if (week.espaldaAlta === true) {
    scale.push({ name: 'espaldaAlta', tag: languages[selected].nordic.body.espaldaAlta });
  }
  if (week.espaldaBaja === true) {
    scale.push({ name: 'espaldaBaja', tag: languages[selected].nordic.body.espaldaBaja });
  }
  if (week.caderaPierna === true) {
    scale.push({ name: 'caderaPierna', tag: languages[selected].nordic.body.caderaPierna });
  }
  if (week.rodilla === true) {
    scale.push({ name: 'rodilla', tag: languages[selected].nordic.body.rodilla });
  }
  if (week.tobilloPie === true) {
    scale.push({ name: 'tobilloPie', tag: languages[selected].nordic.body.tobilloPie });
  }

  return (
    <Box
      sx={{
        overflowY: 'scroll',
        height: '75vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Box
        sx={{
          height: '100%',
          width: '500px',
          maxWidth: '92vw',
          display: 'inline-block',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '12px',
        }}>
        <Typography variant="h5" sx={{ borderBottom: '1px solid grey' }}>
          {languages[selected].nordic.body.scaleQuestion}
        </Typography>
        <NordicToggleButtonGrid name="prueba" valueRange={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} columnVars={scale} />
      </Box>
    </Box>
  );
};

export default NordicWeekScale2;
